<template>
  <div style="height: 100%;margin: 0 30px;overflow: hidden">
    <div class="nothing-data" v-if="serviceArr.length === 0"></div>
    <div v-else :style="{height: 'calc(100% - 10px)', margin: 'auto 0', zoom: 1 / this.golobleObject.zoom}" id="bar" ref="pie_wrap"></div>
  </div>
</template>

<script>
export default {
  name: 'rightBottomType',
  data () {
    return {
      chartPie: null,
      serviceArr: []
    }
  },
  created () {
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.chartPie.resize()
    })
  },
  destroyed () {
  },
  methods: {
    getTypePieData (arr) {
      this.serviceArr = []
      if (arr === null || arr === '') {
        return
      }
      for (let i = 0; i < arr.length; i++) {
        let obj = {
          value: parseInt(arr[i].projectcount),
          name: arr[i].projecttype
        }
        this.serviceArr.push(obj)
      }
      let vm = this
      if (this.serviceArr.length === 0) {
        return
      }
      // console.log('项目类型', arr, this.serviceArr)
      setTimeout(() => {
        vm.getChartPieData()
      }, 300)
    },
    getChartPieData () {
      this.chartPie = this.$echarts.init(this.$refs.pie_wrap)
      this.chartPie.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          left: 'left',
          textStyle: {
            color: '#ffffff'
          }
        },
        // color: ['#e70e0e', '#ea700e', '#75a120', '#259491', '#866FF5'],
        series: [
          {
            name: '服务人数',
            type: 'pie',
            radius: '50%',
            center: ['65%', '50%'],
            data: this.serviceArr,
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  // 平常不显示
                  color: '#fff',
                  textStyle: {
                    fontSize: '12'
                    // fontWeight: 'bold'
                  },
                  // formatter: '{b}\n{c} 人/{d}%'
                  formatter: '{b}\n{d}%'
                }
              }
            }
          }
        ]
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNingComponents/rightBottomType.vue